const API_URL = 'https://vikings.tenb.uk/api/auth';

const register = (username: string, password: string) => {
    return fetch(`${API_URL}/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
    });
};

const login = async (username: string, password: string) => {
    const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to login');
    }

    const data = await response.json();
    if (data.token) {
        localStorage.setItem('userToken', data.token);
    }
    return data;
};

const logout = () => {
    localStorage.removeItem('userToken');
};

const getCurrentUserToken = () => {
    return localStorage.getItem('userToken');
};

const authService = {
    register,
    login,
    logout,
    getCurrentUserToken,
};

export default authService;
